// Copyright ©️ 2026 eVolve MEP, LLC

import { AppShell } from '@mantine/core';

import { navbarTransitionStyle } from 'app/Layout/NavBar/useAppShell';

import { NavBarContent } from './NavBarContent/NavBarContent';

export const DesktopNavBar = () => (
  <AppShell.Navbar
    bg="none"
    withBorder={false}
    style={{
      transition: navbarTransitionStyle,
    }}
  >
    <NavBarContent />
  </AppShell.Navbar>
);
